import { gql } from '@apollo/client';

export const fetchBillingProfilesForTransactionAccount = gql`
  query fetchBillingProfilesForTransactionAccount($id: ID!, $searchOptions: ConnectionSearchOptions) {
    transactionAccount(id: $id) {
      id
      billingProfiles(searchOptions: $searchOptions) {
        totalCount
        nodes {
          id
          name
          currency
          transactionAccountId
          shipToParty {
            id
            name
            addressLine1
            addressLine2
            city
            country
            state
            phone
            postcode
            taxId
            taxIds {
              id
              label
            }
            taxLabels {
              region
              taxIdLabels {
                description
                displayName
                type
              }
            }
          }
          availablePaymentMethods {
            totalCount
            nodes {
              id
              paymentIssue
              type
              default
              ... on CreditCard {
                card {
                  expirationMonth
                  expirationYear
                  last4Numbers
                  brand
                  cardHolderName
                }
              }
              ... on PaymentOnTerms {
                terms {
                  invoiceDueDays
                }
              }
            }
          }
          defaultPaymentMethod {
            id
            type
            paymentIssue
            default
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
              }
            }
          }
          pendingInvoices
          shipToPriceEligibility
          purchaseOrder {
            number
            oneTimeUse
          }
          createdAt
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
